<template>
  <!-- app更新 -->
  <div style="height: 100%;">
    <div style="height: 100%;" class="page_content" v-if="authority">
      <div class="pwd_box" v-if="page_show">
        <div class="input_box">
          <el-input
            class="pwd_item"
            type="password"
            v-model="pwd"
            placeholder="请输入密码"
            @change="submitPwd"
          ></el-input>
          <el-button class="btn" @click="submitPwd">确定</el-button>
        </div>
        <iframe
          class="iframe"
          src="static/bgIndex.html"
          frameborder="0"
        ></iframe>
      </div>
      <div class="page_content" v-else>
        <div class="head">
          <div>
            <el-button type="primary" size="mini" plain @click="hotUpdate"
              >ios更新</el-button
            >
            <el-button type="primary" size="mini" plain @click="appUpdate"
              >Android更新</el-button
            >
          </div>
          <!-- 筛选 -->
          <div class="screening_box">
            <el-select
              v-model="type"
              placeholder="请选择类型"
              @change="selectType"
            >
              <el-option
                :label="item"
                :value="item"
                v-for="item in type_arr"
                :key="item"
              ></el-option>
            </el-select>
          </div>
        </div>
        <!--版本列表 -->
        <div id="table_list">
          <el-table
            ref="table"
            v-load="loading"
            :data="tableData"
            style="width: 100%"
            :height="table_height"
          >
            <el-table-column label="版本">
              <template slot-scope="scope">
                <div class="version">
                  v{{ scope.row.versionnum }}
                  <el-tag
                    class="tag"
                    type="success"
                    disable-transitions
                    size="mini"
                    v-if="scope.$index == 0 && page == 1"
                    >当前版本</el-tag
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column label="类型">
              <template slot-scope="scope">
                {{ changeType(scope.row.type) }}
              </template>
            </el-table-column>
            <el-table-column prop="description" label="更新说明">
            </el-table-column>
            <el-table-column prop="updateon" label="时间"> </el-table-column>
            <el-table-column align="right" label="操作">
              <template slot-scope="scope">
                <el-popconfirm
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  :hideIcon="true"
                  title="确定删除吗？"
                  @confirm="confirmDelete"
                >
                  <el-button
                    slot="reference"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页器 -->
        <Pagination
          :total="total"
          :list="tableData"
          :page="page"
          :pageSize="pageSize"
          @change="changePage"
        />
      </div>

      <!-- 添加更新 -->
      <el-dialog
        :title="is_hot ? 'ios更新' : 'Android更新'"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        @close="cancel"
      >
        <!-- <p class='desc' v-if='!is_hot'>版本更新，用户需要重新安装APP，用于大的修改和更新(只适用Android更新)</p>
                <p class='desc' v-else>APP资源在线更新，用户不需要重新安装APP，用于维护和修复bug(适用Android与ios更新)</p> -->
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <!-- 版本号 -->
          <el-form-item label="版本号" prop="versionnum">
            <el-input
              v-model="ruleForm.versionnum"
              placeholder="请输入版本号"
              clearable
            >
              <template slot="prepend">v</template>
            </el-input>
          </el-form-item>
          <!-- 版本更新说明 -->
          <el-form-item label="版本更新说明">
            <el-input
              :rows="3"
              type="textarea"
              v-model="ruleForm.description"
              placeholder="版本更新说明"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 下载链接 -->
          <el-form-item label="下载链接" v-if="is_hot">
            <el-input
              type="text"
              v-model="ruleForm.downLoadUrl"
              placeholder="请输入ipa下载地址"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 上传wgt文件 -->
          <el-form-item
            class="el_form_item"
            :label="is_hot ? '上传wgt文件' : '上传apk文件'"
          >
            <el-upload
              class="upload_item"
              ref="upload"
              drag
              action=""
              multiple
              :limit="1"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleCrop"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击添加</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传{{ is_hot ? "wgt" : "apk" }}文件
                <span class="file_hint" :class="{ fileHint_show: hint_show }"
                  >请添加文件</span
                >
              </div>
            </el-upload>
            <div class="file_item" v-if="ruleForm.file.name">
              <span>{{ ruleForm.file.name }}</span>
              <i class="el-icon-close" @click="delFile"></i>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="submitForm"
            :loading="updateLoading"
            :disabled="updateLoading"
            >提交更新</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
import mixins from "../../../mixins";

export default {
  mixins: [mixins],
  data() {
    var validateVersion = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入版本号"));
      } else if (this.versionOrNum(value) < this.version) {
        callback(new Error("版本号不能小于当前版本!"));
      } else {
        callback();
      }
    };
    return {
      page_show: true,
      updateLoading: false,
      pwd: "",
      row_index: 0,
      id: "",
      version: "",
      type_arr: ["全部", "ios更新", "Android更新"],
      type: "",
      dialogFormVisible: false,
      is_hot: true, // 是否热更新
      // 表单
      ruleForm: {
        versionnum: "",
        description: "",
        downLoadUrl: "",
        file: {}
      },
      // 表单检验规则
      rules: {
        versionnum: [
          // { required: true, message: '请输入版本号', trigger: 'blur' },
          { validator: validateVersion, trigger: "blur" }
        ]
      },
      hint_show: false,
      dialog_top: "15vh",
      changeType(type) {
        let type_name = "";
        type == 1 ? (type_name = "ios更新") : (type_name = "Android更新");
        return type_name;
      }
    };
  },
  watch: {
    "ruleForm.file": {
      handler(newName, oldName) {
        if (JSON.stringify(newName) != "{}") {
          this.hint_show = false;
        } else {
          this.hint_show = true;
        }
      },
      deep: true
    }
    //    "ruleForm.versionnum": {
    //         handler(newName, oldName) {
    //             if(newName ) {
    //                 this.hint_show = false;
    //             }
    //         },
    //         deep: true
    //     },
  },
  methods: {
    // 获取列表
    getList() {
      if (!this.authority) return;
      this.loading = true;
      if (!this.page_show) this.tableScrollTop();
      this.$http({
        url: this.$api.update_list,
        data: {
          type: this.type,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.total = res.data.total;
            this.tableData = res.data.concent;
            if (this.page == 1)
              this.version = this.versionOrNum(res.data.concent[0].versionnum);
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 更新
    update() {
      this.updateLoading = true;
      if (this.is_hot) {
        this.ruleForm.type = 1;
        // if(this.ruleForm.downLoadUrl != "") this.ruleForm.file = JSON.stringify({});
        if (
          JSON.stringify(this.ruleForm.file) == "{}" ||
          Boolean(this.ruleForm.file)
        )
          this.ruleForm.file = "";
      } else {
        this.ruleForm.type = 2;
      }
      let is_title = this.ruleForm.versionnum.indexOf("v");
      if (is_title != -1)
        this.ruleForm.versionnum = this.ruleForm.versionnum.slice(1);
      let formData = new FormData();
      Object.keys(this.ruleForm).forEach(key => {
        formData.append(key, this.ruleForm[key]);
      });
      this.$http({
        url: this.$api.update,
        data: formData
      }).then(res => {
        this.updateLoading = false;
        if (res.code == 0) {
          this.page = 1;
          this.getList();
          this.$hint("添加成功");
          this.cancel();
        } else {
          this.$hint("添加失败", "err");
        }
      });
    },
    // 删除列表条目
    delUpdate() {
      this.$http({
        url: this.$api.del_update + "/" + this.id,
        method: "get"
      }).then(res => {
        if (res.code == 0) {
          this.tableData.splice(this.row_index, 1);
          this.total--;
          this.$hint("删除成功");
        } else {
          this.$hint("删除失败", "err");
        }
      });
    },
    // 点击热更新
    hotUpdate() {
      this.is_hot = true;
      this.dialogFormVisible = true;
      this.ruleForm = {
        downLoadUrl: "",
        file: {}
      };
    },
    // 点击版本更新
    appUpdate() {
      this.is_hot = false;
      this.dialogFormVisible = true;
      this.ruleForm = {
        file: {}
      };
    },
    // 文件上传
    handleCrop(file) {
      this.$refs.upload.clearFiles();
      let file_name = file.name;
      let name_index = file_name.lastIndexOf(".");
      file_name = file_name.slice(name_index + 1, file_name.length);
      if (this.is_hot && file_name == "wgt") {
        console.log("wgt文件");
        this.ruleForm.file = file.raw;
      } else if (!this.is_hot && file_name == "apk") {
        console.log("apk文件");
        this.ruleForm.file = file.raw;
      } else {
        let err_text = "wgt";
        if (!this.is_hot) err_text = "apk";
        this.$hint("文件格式错误,请上传." + err_text + "后缀名的文件", "err");
      }
    },
    // 删除文件
    delFile() {
      this.ruleForm.file = {};
    },
    // 筛选类型
    selectType(e) {
      switch (e) {
        case "全部":
          this.type = "";
          break;
        case "热更新":
          this.type = 1;
          break;
        case "Android版本更新":
          this.type = 2;
          break;
      }
      this.page = 1;
      this.getList();
    },
    // 提交更新
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.is_hot) {
            this.update();
          } else {
            if (JSON.stringify(this.ruleForm.file) == "{}") {
              this.hint_show = true;
            } else {
              this.update();
            }
          }
        }
      });
    },
    // 点击取消
    cancel() {
      this.dialogFormVisible = false;
      this.$refs.ruleForm.resetFields();
      this.ruleForm.file = {};
      this.$nextTick(() => {
        this.hint_show = false;
      });
    },
    // 点击删除
    handleDelete(index, row) {
      this.id = row.versionid;
      this.row_index = index;
    },
    // 确定删除
    confirmDelete() {
      this.delUpdate();
    },
    // 转换版本号为数字
    versionOrNum(e) {
      let arr = e.split(".");
      let num = arr.join("");
      return Number(num);
    },
    submitPwd() {
      if (this.pwd == "2020") {
        this.page_show = false;
        this.$nextTick(() => {
          this.changeTableHeight("init");
        });
      }
    }
  }
};
</script>

<style>
.el-form-item__label {
  text-align: left !important;
}

@keyframes leftMove {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(0%);
  }
}
@keyframes rightMove {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(0%);
  }
}
</style>
<style lang="less" scoped>
.version {
  display: flex;
  align-items: center;
  .tag {
    margin: 0;
    margin-left: 10px;
  }
}
.page_content {
  height: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.pwd_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 6px;
  position: relative;
  .input_box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 99;
    display: flex;
    align-items: center;
    .pwd_item {
      width: 400px;
      height: 40px;
      margin-right: 10px;
      animation: leftMove 0.8s;
    }
    .btn {
      height: 34px;
      animation: rightMove 1s;
      font-size: 13px;
      transform: translateY(-2px);
    }
  }
  .iframe {
    width: 100%;
    height: 100%;
  }
}
.desc {
  font-size: 12px;
  color: #999;
  position: absolute;
  top: 60px;
  left: 30px;
}
.el_form_item {
  display: flex;
  flex-direction: column;
  .upload_item {
    .el-upload__tip {
      margin: 0;
      line-height: 0;
      .file_hint {
        color: #f56c6c;
        margin-left: 10px;
        opacity: 0;
        transform: translateY(10px);
        transition: all 0.5s;
      }
      .fileHint_show {
        opacity: 1;
        transform: translateY(0px);
      }
    }
  }
  .file_item {
    width: 40%;
    background: #f9f9f9;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 5px;
    &:hover {
      .el-icon-close {
        display: block;
      }
    }
    .el-icon-close {
      display: none;
      &:hover {
        color: #f56c6c;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/update.vue